const styles = theme => ({
  eye: {
    cursor: 'pointer',
  },
});

export default styles;
